import { render, staticRenderFns } from "./stockOccupyData.vue?vue&type=template&id=0ca582d9"
import script from "./stockOccupyData.vue?vue&type=script&lang=js"
export * from "./stockOccupyData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports